import React from 'react';

import InspireSlider from './InspireSlider/InspireSlider';
import NextSectionButton from '../../components/NextSectionButton/NextSectionButton';

import { sectionIds } from '../../utils/constants';

import DeskCrop from '../../assets/img/desk-crop.png';
import MobCrop from '../../assets/img/mob-crop.png';

import './Intro.scss';
import useDeviceTypeDetector from '../../hooks/useDeviceTypeDetector';

const IntroSection = () => {
  const { isMobile } = useDeviceTypeDetector();

  return (
    <section className="intro-section" id={sectionIds.intro}>
      <div className="content">
        <InspireSlider />
        <div className="image-wrapper">
          <NextSectionButton
            title="о приложении"
            sectionId={sectionIds.about}
          />
          <img
            src={isMobile ? MobCrop : DeskCrop}
            className="mobile-app"
            alt="mobile application interface cropped"
          />
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
